export const enum Basketball3x3ResultId {
  Result = 2,
  RegularTime = 3,
  Overtime = 104,
}
